import React, { useEffect, useMemo, useState } from "react";
import APIService from "../../Service/APIService";
import { AgCharts } from "ag-charts-react";
import "./Home.css";
import { Skeleton } from "antd";

const tinyTextTheme = {
  fontFamily: "Figtree, system-ui, -apple-system, BlinkMacSystemFont, sans-serif",
  fontSize: 12,
};

const formatCurrency = (value) =>
  `$${Number(value).toLocaleString("en-US", {
    maximumFractionDigits: 0,
  })}`;

const formatCompactCurrency = (value) => {
  if (value >= 1_000_000) {
    return `$${(value / 1_000_000).toFixed(1).replace(/\.0$/, "")}M`;
  }

  if (value >= 1_000) {
    return `$${(value / 1_000).toFixed(1).replace(/\.0$/, "")}K`;
  }

  return `$${value}`;
};

const transformSalesData = (data) =>
  data.map((item) => ({
    Month: item.Month,
    Sales: Number(item.Sales),
    SalesParse: formatCurrency(item.Sales),
  }));

const SalesChart = ({ isYearlySales }) => {
  const [yearlyData, setYearlyData] = useState([]);
  const [sixMonthData, setSixMonthData] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchData = async () => {
    try {
      const apiService = new APIService();
      const response = await apiService.getDataFromBackend("saleschartdata");
      const sales = response?.data?.data ?? [];

      const formatted = transformSalesData(sales);

      setYearlyData(formatted);
      setSixMonthData(formatted.slice(-6));
    } catch (error) {
      console.error("Failed to load sales chart data", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const chartData = isYearlySales ? yearlyData : sixMonthData;

  const chartOptions = {
  data: chartData,

  padding: {
    top: 16,
    right: 16,
    bottom: 16,
    left: 0,
  },

  series: [
    {
      type: "area",
      xKey: "Month",
      yKey: "Sales",
      yName: "Realized Sales",
      interpolation: { type: "smooth" },

      marker: {
        enabled: true,
        size: 4,
      },

      tooltip: {
        renderer: ({ datum }) => ({
          title: datum.Month,
          content: `<span style="font-size:12px;">${datum.SalesParse}</span>`,
        }),
      },
    },
  ],

  axes: [
    {
      type: "category",
      position: "bottom",
      label: {
        ...tinyTextTheme,
      },
    },
    {
  type: "number",
  position: "left",
  label: {
    ...tinyTextTheme,
    formatter: ({ value }) => formatCompactCurrency(value),
  },
  gridLine: {
    style: [
      {
        stroke: "#E5E7EB",
        lineDash: [4, 4],
      },
    ],
  },
}
  ],

  theme: {
    baseTheme: "ag-default",
    overrides: {
      common: {
        ...tinyTextTheme,
      },
      area: {
        series: {
          fillOpacity: 0.55,
          strokeWidth: 2,
        },
      },
    },
  },
};

  if (loading) {
  return (
    <div style={{ padding: 16 }}>
      <Skeleton
        active
        title={false}
        paragraph={{ rows: 9 }}
        style={{ width: "100%", minheight: "340px" }}
      />
    </div>
  );
}

  return (
    <AgCharts
      options={chartOptions}
      style={{ width: "100%", minHeight: "340px" }}
    />
  );
};

export default SalesChart;